/* eslint-disable camelcase */
import { APIHandler, DataHandler, StorageHandler } from 'C4';
import { storageKeys } from 'settings';

const AppSettings = async () => {
  const appId = await DataHandler.matchAppId();
  const appInfo = await APIHandler.getAppInfo(appId);

  if (appInfo) {
    const {
      landingVideo,
      logo,
      logo_white,
      logo_wide_color,
      logo_wide_white,
      splashScreen,
      primary_color,
      secondary_color,
      landing_quote,
      programBenefits,
      facebook,
      flickr,
      instagram,
      twitter,
      youtube,
      pinterest,
      googlePlus,
      linkedin,
      appName,
      login_image,
      question_header,
      google_play_url,
      apple_store_url,
    } = appInfo.app[0];

    const socials = {
      facebook: facebook !== '' ? facebook : null,
      flickr: flickr !== '' ? flickr : null,
      instagram: instagram !== '' ? instagram : null,
      twitter: twitter !== '' ? twitter : null,
      youtube: youtube !== '' ? youtube : null,
      pinterest: pinterest !== '' ? pinterest : null,
      googlePlus: googlePlus !== '' ? googlePlus : null,
      linkedin: linkedin !== '' ? linkedin : null,
    };

    const appInfoObject = {
      backgroundImage: splashScreen
        ? splashScreen.replace(
            's3.amazonaws.com/developertool',
            'front.travpromobile.com'
          )
        : null,
      backgroundVideo: landingVideo
        ? landingVideo.replace(
            's3.amazonaws.com/developertool',
            'front.travpromobile.com'
          )
        : null,
      loginImage: login_image
        ? login_image.replace(
            's3.amazonaws.com/developertool',
            'front.travpromobile.com'
          )
        : null,
      logo: logo
        ? logo.replace(
            's3.amazonaws.com/developertool',
            'front.travpromobile.com'
          )
        : null,
      logoWhite: logo_white
        ? logo_white.replace(
            's3.amazonaws.com/developertool',
            'front.travpromobile.com'
          )
        : null,
      logoWide: logo_wide_color
        ? logo_wide_color.replace(
            's3.amazonaws.com/developertool',
            'front.travpromobile.com'
          )
        : null,
      logoWideWhite: logo_wide_white
        ? logo_wide_white.replace(
            's3.amazonaws.com/developertool',
            'front.travpromobile.com'
          )
        : null,
      primaryColor: primary_color !== '' ? primary_color : null,
      secondaryColor: secondary_color !== '' ? secondary_color : null,
      landingQuote: landing_quote !== '' ? landing_quote : null,
      appName: appName !== '' ? appName : null,
      questionHeader: question_header
        ? question_header.replace(
            's3.amazonaws.com/developertool',
            'front.travpromobile.com'
          )
        : null,
      programBenefits,
      socials,
      appleStore: apple_store_url,
      googlePlay: google_play_url,
    };

    StorageHandler.save(storageKeys.appInfo, appInfoObject);

    return true;
  }
};

export default AppSettings;
